module.exports = __webpack_public_path__ + "img/qiubojun.b9afbc9d.jpg";